export default {
  app: {
    login: 'Logg inn',
    logout: 'Logg ut',
    loggingIn: 'Loggar inn',
    withoutFeide: 'Utan feide',
    skipToContent: 'Hopp til hovudinnhald',
    back: 'Tilbake'
  },
  login: {
    title: 'Logg inn i Aschehoug VGS',
    message: 'Du er logget ut. Vennligst logg inn.'
  },
  home: {
    title: 'Heim',
    welcome: 'Velkommen til Aschehoug VGS',
    subjectTitle: 'Fag'
  },
  footer: {
    uu: 'Universell utforming',
    service: 'Kundeservice',
    privacy: 'Personvern',
    store: 'Nettbutikk',
    copyrights: 'Rettar til innhald',
    feedback: 'Gi tilbakemelding',
  },
  resourceGuide: {
    what: 'Kva?',
    how: 'Korleis?',
    why: 'Kvifor?',
  },
  topicGuide: {
    justification: 'Begrunning',
    preparations: 'Førebuing',
    differentiation: 'Differensiering',
    evaluation: 'Vurdering',
    execution: 'Gjennomføring',
  },
  topicPage: {
    taskText: 'Oppgåver og aktivitetar',
    teacherContent: {
      title: 'Finn fleire ressursar',
      text: 'Som lærer har du tilgang til fleire oppgåver og aktivitetar som du kan dela med elevane frå eiga eining.',
      exploreContent: 'Utforsk innhald'
    }
  },
  teacherResourceBank: {
    resource: 'Ressursbank',
    summary: 'Her finn du ei oversikt over oppgåver og aktivitetar som kan brukast i arbeidet med dette temaet.'
  },
  subject: {
    title: 'Fagside',
    'subject-resource': 'Fagressursar',
    'to-teacher': 'Til lærar',
    'to-teacher-subject': 'Om læremiddelet',
  },
  'subject-article': {
    'guide-button': 'Lærarrettleiing',
    'goal-button': 'Kompetansemål'
  },
  callouts: {
    'not-found-sub-elements': 'Faget har ingen underelementer'
  },
  expandBlock: {
    examples: 'Døme',
    'action-text': 'Sjå løysingsforslag'
  },
  language: {
    nb: 'Bokmål',
    nn: 'Nynorsk'
  },
  settings: {
    title: 'Innstillingar',
    language: 'Målform'
  },
  notFound: {
    title: 'Oops! Sida du leitar etter finst ikkje.',
    text: 'Stava du adressa rett?',
    link: 'Ta meg heim'
  },
  imageCredits: 'Biletrettar',
  navigateTo: 'Naviger til',
  authors: 'Skreve av',
  loadingContent: 'Lastar innhald',
  comingSoon: 'Kjem snart',
  loginWithFeide: 'Logg inn',
  download: {
    urge: 'Last ned "{file}"',
    failed: 'Noko gjekk galt ved nedlastinga av fila',
  },
  introduction: 'Introduksjon',
  preparation: 'Førebuing',
  mimeType: {
    pdf: 'PDF',
    word: 'Word',
    excel: 'Rekneark',
    video: 'Video',
    audio: 'Lydfil',
    image: 'Bilde',
    powerpoint: 'Presentasjon',
    archive: 'Arkiv',
    file: 'Fil',
  },
  task: {
    stepTitle: 'Steg',
    taskTitle: 'Oppgåve',
    needHelp: 'Treng du hjelp?',
  },
  assignments: {
    noAssignments: 'Ingen oppgåver er lagde til',
    noPictures: 'Ingen bilete er lagde til',
  },
  credits: 'Kreditering',
  explanation: 'Forklaring',
  welcomeMessage: {
    getToKnow: 'Bli kjend med Modus',
    trySubjects: 'Prøv smakebitar av dei første faga våre. Vi legg til innhald i desse fortløpande. Snart kjem det også innhald frå fleire fag.'
  },
  audioPlayer: {
    listenToTheText: 'Lytt til teksten',
    pauseAudio: 'Pause lyd',
    playAudio: 'Spel av lyd',
    close: 'Lukk'
  },
  pageXofY: 'Side {x} av {y}',
  frontPage: {
    digitalTeachingAid: 'Eit digitalt læremiddel for vidaregåande skule frå Aschehoug'
  },
  subjectPage: {
    subject: 'Tema'
  },
  uuPage: {
    title: 'Universell utforming i Modus frå Aschehoug',
    welcome: 'Velkommen til vårt digitale læremiddel for vidaregåande skular, Modus. Vi utviklar universelt utforma læremiddel med lærar og elev i fokus.',
    compliance: {
      heading: 'Modus følgjer alle lovkrav til universell utforming',
      text1: 'Aschehoug skole følgjer lovkrava i Forskrift om universell utforming av ikt-løsninger, oppfyller dei 35 suksesskriteria i Retningslinjer for tilgjengelig webinnhold (WCAG) 2.0 og oppfyller reglane i EUs webdirektiv (WAD) som trådde i kraft 1. februar 2023. Du kan lese meir om lovkrava på UU tilsynets',
      text2: 'sider',
      text3: 'I Aschehoug skole er vi opptatt av å utvikle digitale læremiddel som er gode å bruke for alle elevar og lærarar. Vi jobbar derfor kontinuerleg med universell utforming.'
    },
    accessibilityFeatures: {
      heading: 'Tilgjengelegheitsfunksjonar i Modus',
      fontSize: {
        heading: 'Justere skriftstorleik',
        text: 'Hald ctrl-tasten nede (cmd-tasten på Mac) og trykk samtidig på pluss-tasten for å forstørre teksten, eller trykk på minus-tasten for å forminske teksten.'
      },
      listenToText: {
        heading: 'Lytte til teksten',
        text: 'I Modus kan du lytte til teksten ved hjelp av skjermlesarar og innebygd funksjonalitet på PC-ar, Mac, iOS og Android.'
      },
      linksAndDocuments: {
        heading: 'Lenker og dokument',
        text: 'I Modus markerer vi der kor lenker blir opna i ei ny fane (gjeld eksternt innhald) eller leier til nedlastbare filer.'
      },
      keyboardNavigation: {
        heading: 'Tastaturnavigasjon',
        text1: 'Modus ivaretar personar som ikkje kan navigere med mus. Innhald kan navigerast og brukast ved hjelp av tastatur.',
        text2: 'Tab-tasten kan brukast for å hoppe mellom aktive element på ei side. Hald inne tab-tasten og shift-tasten samtidig for å gå tilbake eit steg, og bruk enter-tasten for å aktivere eit markert element.',
        text3: 'I nokre situasjonar kan piltastane brukast for å interagere med visse typar element, som til dømes å spole gjennom lydklipp og video, endre volum, interagere med enkelte menyar og nedtrekksmenyar.',
        text4: 'Mellomrom-tasten kan brukast til å pause og starte lyd og video.',
        text5: 'Nokre typar innhald er unntatt krav til tastaturnavigasjon. På Modus kan dette til dømes kunne gjelde teikneverktøy. Nokre typar oppgåver vil også mangle tastaturnavigasjon, og i dei tilfella er ei alternativ oppgåve med tastaturnavigasjon tilgjengeleg.'
      },
      altText: {
        heading: 'Alternativ bilettekst',
        text: 'I Modus har bilete ein alternativ bilettekst som skildrar relevant informasjon i biletet.'
      },
      videoCaptioning: {
        heading: 'Teksting av video',
        text: 'Videoar i Modus er teksta.'
      },
      supportedDevices: {
        heading: 'Oversikt over støtta einingar',
        text: 'Vi har testa Modus i følgjande nettlesarar, operativsystem/einingar og verktøy: Nettlesarar:'
      },
      feedback: {
        heading: 'Tilbakemeldingar',
        text1: 'Vi set stor pris på å få tilbakemeldingar dersom det er ting som ikkje fungerer eller kunne vore løyste betre, slik at læremidla våre blir endå betre å bruke. Her finn du kontaktinformasjonen vår. Lenke til ',
        text2: 'kundeservice'
      }
    }
  },
  contentRightsPage: {
    title: 'Rettar til innhald i Modus',
    attentionHeader: 'Ver merksam på dette:',
    contentOwnership: 'Alt innhald i Modus, som tekstar, bilete, illustrasjonar, logoar og programkode, tilhøyrer Aschehoug forlag eller våre lisensgivarar. Dette innhaldet er beskytta av relevante lover, særleg åndsverklova og varemerkelova.',
    usageRestrictions: 'Det er derfor ikkje tillatt å gjenbruke innhaldet ved til dømes å dele det eller kopiere det inn i andre program. Dette gjeld med mindre slik bruk er tillatt etter lov eller gjennom avtale med Kopinor (interesseorgan for innehavarar av rettar til åndsverk). Dermed er det heller ikkje tillatt å mate innhald frå Modus inn i programvare for kunstig intelligens, eller på annan måte bruke det til å utvikle eller bearbeide maskinlæringsalgoritmar.',
    userResponsibility: 'Som brukar er du sjølv ansvarleg for at innhald du legg inn i Modus eller gjer tilgjengeleg for andre gjennom tenesta, ikkje bryt med nokon sine rettar.'
  },
  'privacyPage': {
    title: 'Personvern i Modus frå Aschehoug',
    introduction: 'Velkommen til vårt digitale læremiddel Modus. Vi utviklar læremiddel med lærar og elev i fokus. På denne sida finn du informasjon om korleis Aschehoug handterar elevar og lærarar sitt personvern i tenestene våre for vidaregåande opplæring.',
    privacyHeader: 'Personvern',
    privacyText1: 'Du kan lese om korleis vi behandlar personopplysningar i',
    privacyText2: 'personvernerklæringa vår.',
    agreementsHeader: 'Avtaler med skuleeigarar',
    agreementsText: 'Aschehoug har allereie avtalar med dei fleste skuleeigarar i landet. Ta gjerne kontakt med oss for å få vite om skuleeigaren din allereie har ein slik avtale med oss. Om du ønskjer å gjennomlese eller signere databehandlaravtale, kontakt',
    subcontractorsHeader: 'Underleverandørar',
    subcontractorsText: 'Nokre av Aschehoug sine underleverandørar har tilgang til persondata gjennom dei tenestene dei leverer til oss. Aschehoug har databehandlaravtalar med alle desse. Sjå oversikt over underleverandørane våre.',
    subcontractorsTableHeaders: {
      name: 'Namn på underleverandør',
      serviceType: 'Type verksemd/teneste som blir levert',
      serverLocation: 'Stadleg plassering for serverdrift'
    },
    contactHeader: 'Kontakt',
    contactText: 'Dersom du har spørsmål knytte til personvern i Modus, ta gjerne kontakt med oss:'
  }
}
